import {
  Table,
  TableData,
  TableHead,
  TableHeader,
  Typography,
} from "~/common/components";
import { TYPOGRAPHY_VARIANTS } from "~/common/utils";
import { MedicationsData } from "~/providers/utils/types/patientPreviewTypes";

interface PatientPreviewCurrentMedicationsProps {
  medications?: MedicationsData[];
}

export const PatientPreviewCurrentMedications = ({
  medications,
}: PatientPreviewCurrentMedicationsProps) => {
  if (!medications)
    return (
      <section>
        <Typography variant={TYPOGRAPHY_VARIANTS.light}>
          No medications reported
        </Typography>
      </section>
    );

  return (
    <Table className="table-auto rounded-xl border">
      <TableHead>
        <tr>
          <TableHeader className="rounded-tl-xl px-6">
            Medication name
          </TableHeader>
          <TableHeader className="px-6">Dose</TableHeader>
          <TableHeader className="rounded-tr-xl px-6">Frequency</TableHeader>
        </tr>
      </TableHead>
      <tbody className="bg-white text-sm text-gray-70">
        {medications?.map(({ name, dose, frequency }) => (
          <tr
            key={name}
            className="border-b border-gray-300 py-4 last:border-none"
          >
            <TableData className="rounded-b-xl py-4">{name}</TableData>
            <TableData className="py-4">{dose}</TableData>
            <TableData className="rounded-b-xl py-4">{frequency}</TableData>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
